import { S141gS141m01Component } from './s141g-s141m01.component';

export { S141gModule } from './s141g.module';

export const S141gSubComponentsMap = {
	
};

export const S141gComponentsMap = {
	"s141g-s141m01": S141gS141m01Component
};

export const S141gComponents = [
	S141gS141m01Component
];

